<form
  [formGroup]="form"
  [patchForm]="configurationOption"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <div class="row">
    <div class="col-lg-6">
      <div class="mb-4">
        <label class="form-label">
          {{ 'general.key' | translate }}
          <small>({{ 'general.isRequired' | translate }})</small>
        </label>

        <input
          class="form-control"
          [attr.aria-invalid]="
            form.controls.key.dirty && form.controls.key.invalid ? 'true' : null
          "
          type="text"
          formControlName="key"
          required
        />

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.key.dirty && form.controls.key.invalid"
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'general.key' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4" [hidden]="showCalendar">
        <label class="form-label">
          {{ 'general.value' | translate }}
          <small>({{ 'general.isRequired' | translate }})</small>
        </label>

        <input
          class="form-control"
          [attr.aria-invalid]="
            form.controls.value.dirty && form.controls.value.invalid
              ? 'true'
              : null
          "
          type="text"
          formControlName="value"
          required
        />

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.value.dirty && form.controls.value.invalid"
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'general.value' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="form-footer">
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!form.dirty && !this.showCalendar"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
  <div class="mt-2" *ngIf="showCalendar">
    <year-calendar
      [originalCalendar$]="sendCalendar$.asObservable()"
      [getDataFromCalendar$]="getDataFromCalendar$.asObservable()"
      (onSelectedDates)="transformData($event)"
    ></year-calendar>
  </div>
</form>
